<template>
  <v-hover v-slot="{ hover }" close-delay="200">
    <v-card
      :elevation="hover ? 8 : 2"
      :class="{ 'on-hover': hover }"
      class="mx-auto"
      :height="height"
      :width="width"
      @click="onClick"
    >
      <img :src="src" />
    </v-card>
  </v-hover>
</template>

<script>
import locationService from '@/services/location'
import { GOOGLE_MAPS_API_KEY } from '@/config'

export default {
  props: {
    label: { default: '' },
    mgrs: { default: null },
    lat: { default: null },
    long: { default: null },
    width: { default: 600 },
    height: { default: 300 },
    zoom: { default: locationService.zoom }
  },
  data() {
    return {
      apiKey: GOOGLE_MAPS_API_KEY
    }
  },
  computed: {
    mapLocation() {
      if (this.mgrs) {
        const p = locationService.getLatLng(this.mgrs)
        return `${p.latitude},${p.longitude}`
      }

      return `${this.lat},${this.long}`
    },
    size() {
      return `${this.width}x${this.height}`
    },
    markers() {
      return `size:tiny|color:red|${this.mapLocation}`
    },
    src() {
      return `https://maps.googleapis.com/maps/api/staticmap?center=${this.mapLocation}&size=${this.size}&zoom=${this.zoom}&markers=${this.markers}&key=${this.apiKey}`
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style>
.on-hover {
  cursor: pointer;
}
</style>
